import { render, staticRenderFns } from "./LawLedesList.vue?vue&type=template&id=3dfba79c&"
import script from "./LawLedesList.vue?vue&type=script&lang=js&"
export * from "./LawLedesList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesList.vue?vue&type=style&index=0&id=3dfba79c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports